import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.8 23H3.2A2.2 2.2 0 0 1 1 20.8V3.2A2.2 2.2 0 0 1 3.2 1h17.6A2.2 2.2 0 0 1 23 3.2v17.6a2.2 2.2 0 0 1-2.2 2.2zm-8.959-11.108h-1.558V8.744h1.541c.598 0 1.064.132 1.396.399.333.267.5.655.5 1.166v.033c0 .477-.167.855-.5 1.133-.332.278-.793.417-1.379.417zM7 6v11.85h3.283v-3.386h1.626c.734 0 1.414-.09 2.039-.27a4.568 4.568 0 0 0 1.617-.813 3.76 3.76 0 0 0 1.058-1.338c.254-.53.381-1.144.381-1.843v-.036c0-.654-.116-1.241-.347-1.76a3.578 3.578 0 0 0-.99-1.311 4.45 4.45 0 0 0-1.557-.813A6.947 6.947 0 0 0 12.078 6H7z"
});

var SvgParkingFilled = function SvgParkingFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgParkingFilled;